var AudioPlayer = {

    element: null,

    promise: null,

    prepared: false,

    enabled_element: null,

    platform: window.navigator.platform,

    applePlatforms: ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'iPhone', 'iPad', 'iPod'],

    isApple: function (){

        return this.applePlatforms.indexOf(this.platform) !== -1

    },

    init: function (element, enabler_element){

        this.enabler_element = enabler_element;

        this.enabler_element.hidden = true;

        this.enabler_element.dataset.hidden = "true";

        this.element = new Audio( element.dataset.srcMp3 );
        this.element.loop = true;
        this.element.autoplay = false;

        this.test();

        return this;

    },

    test: function (){

        var _this = this;

        this.audioOff();

        this.promise = this.element.play();

        this.promise.then(function (){

            _this.playable();

        }).catch(function (){

            _this.blocked();

        });

    },

    playable: function (){
        console.log("playable");

        this.stop();

        this.audioOn();
    },

    blocked: function (){
        console.log("blocked");

        var _this = this;

        this.enabler_element.hidden = false;

        this.enabler_element.dataset.hidden = "false";

        document.addEventListener("mousedown", function (){_this.prepare()});
        document.addEventListener("touchstart", function (){_this.prepare()});
        document.addEventListener("keydown", function (){_this.prepare()});
        this.enabler_element.addEventListener("click", function (){_this.prepare()});
    },

    prepare: function (){

        if (this.prepared){

            return;

        }
        console.log("prepare");

        var _this = this;

        this.audioOff();

        this.element.play();
        this.element.pause();

        this.element.currentTime = '0';

        this.element.muted = false;

        this.enabler_element.dataset.hidden = "true";

        setTimeout(function (){

            _this.enabler_element.hidden = true;

        }, 2000);

        this.prepared = true;

    },

    audioOff: function (){

        if (this.isApple()){

            this.element.audio = 0.1;

        }else{

            this.element.muted = true;

        }

    },

    audioOn: function (){

        if (this.isApple()){

            this.element.audio = 1;

        }else{

            this.element.muted = false;

        }

    },

    stop: function (){

        this.element.pause();
        this.element.currentTime = '0';

    },

    play: function (){

        this.element.play();

    },

};
